module.exports = __webpack_public_path__ + "media/images/caret-down-a5ffa1393eb9980e3e14e1aa2d02405c.svg";